import React from 'react';
import Loader from './loader';
import { requestStatus } from '../constants';

class NetworkLoader extends React.Component {
    renderLoader() {
        let LoaderComponent = this.props.loader || Loader;
        return (
            <LoaderComponent />
        )
    }

    renderChildren() {
        if (this.props.status === requestStatus.BUSY) {
            return this.renderLoader();
        } else {
            return this.props.children;
        }
    }

    render () {
        return <div {...this.props} className={['component-network-loader', this.props.className].join(' ')}>
            {
                this.renderChildren()
            }
        </div>
    }
}

export default NetworkLoader;



// WEBPACK FOOTER //
// ./web-app/components/network-loader.jsx